import Banner from "./Banner";
import Star from "./Star.js";
import WhoMe from "./WhoWe.js";
import LifeProContent from "./LifeProContent.js";
import Treatment from "./Treatment.js";
import Culture from "./Culture.js";
import Prize from "./Prize.js";
import PromotionPath from "./PromotionPath.js";
import Training from "./Training.js";
import ListManager from "./ListManager.js";
import Contact from "./Contact.js";
import { useEffect, useRef } from "react";

const App = () => {
  const treatmentRef = useRef(null);
  const cultureRef = useRef(null);
  const prizeRef = useRef(null);
  const promotionPathRef = useRef(null);
  const trainingRef = useRef(null);

  useEffect(() => {
    const path = window.location;
    if (path.hash !== "" || path.pathname !== "/lifepro") {
      window.location.href = "/lifepro";
    }
  }, []);

  return (
    <div className="overflow-hidden">
      <Banner />
      <WhoMe />
      <Star />
      <LifeProContent
        treatmentRef={treatmentRef}
        cultureRef={cultureRef}
        prizeRef={prizeRef}
        promotionPathRef={promotionPathRef}
        trainingRef={trainingRef}
      />
      <Treatment treatmentRef={treatmentRef} />
      <Culture cultureRef={cultureRef} />
      <Prize prizeRef={prizeRef} />
      <PromotionPath promotionPathRef={promotionPathRef} />
      <Training trainingRef={trainingRef} />
      <ListManager />
      <Contact />
    </div>
  );
};

export default App;
